import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';  // Importar ThemeProvider
import CssBaseline from '@mui/material/CssBaseline';   // Importar CssBaseline para normalizar estilos
import theme from './theme';                           // Importar el theme que vamos a crear

ReactDOM.render(
  <ThemeProvider theme={theme}>   {/* Envolver la app con el ThemeProvider */}
    <CssBaseline />               {/* CssBaseline para estilos básicos */}
    <Router>
      <App />
    </Router>
  </ThemeProvider>,
  document.getElementById('root')
);
